<template>
<div>

	<div v-if="breadcrumb.length > 0">
		<nav>
			<ol class="breadcrumb">
				<li class="breadcrumb-item"><a href="#"><i class="fa fa-arrow-up" v-on:click="upCategory"></i></a></li>
				<li class="breadcrumb-item" :class="{active: index == breadcrumb.length - 1}" v-for="(cat,index) in breadcrumb">
					<a v-if="index != breadcrumb.length - 1" href="#" v-on:click="toCat(cat)">{{ cat.name }}</a>
					<span v-else>{{cat.name}}</span>
				</li>
			</ol>
		</nav>
	</div>

	<context-menu  class="float-right"
		:menu-items="contextMenuItems"
		v-on:itemClick="contextMenuClick">
	</context-menu>

	<widget v-if="showImportCategories" title="Import Categories (.csv)" header-button="fa-times" v-on:headerButtonClick="showImportCategories = false">

		<p v-if="selectedCategory">This allows you to upload a list of categories into the "{{selectedCategory.name}}" category</p>

		<p v-else>This allows you to upload a list of categories into the top level categories.</p>

		<p><strong>Example:</strong></p>

		<table class="spreadsheet-table mb-3">
			<tr>
				<th></th>
				<th>A</th>
			</tr>
			<tr>
				<th>1</th>
				<td>Pipe</td>
			</tr>
			<tr>
				<th>2</th>
				<td>Plastic Pipe</td>
			</tr>
			<tr>
				<th>3</th>
				<td>Metal Pipe</td>
			</tr>
		</table>

		<input type="file" class="form-control mb-2" v-on:change="importCSV(categoryApiResource,$event)">
	</widget>

	<div v-if="working">
		<spinner></spinner>
	</div>
	<div v-else-if="!selectedCategory || !categoryCanHaveRecords">
		<h3><i v-if="selectedCategory" class="fa fa-arrow-up icon-button" v-on:click="upCategory"></i> {{ selectedCategory ? selectedCategory.name : 'Categories'}}</h3>

		<div style="clear: both;"></div>
		<ul v-if="records.length == 0 && selectedChildCategories.length > 0" class="list-group categories-list mb-2">
			<li class="list-group-item" v-for="cat in selectedChildCategories" v-on:click="openCat(cat)">
				{{ cat.name }}
				<!--<div v-if="cat[numRecordsField]" class="count-badge float-right">{{ cat[numRecordsField] }}</div>-->
			</li>
		</ul>
		<p v-else-if="selectedCategory">No sub-categories in "{{selectedCategory.name}}"</p>
		<div v-else class="alert alert-info">
			No categories. Add a category by clicking the <i class="fa fa-fw fa-ellipsis-v"></i> button in the top right.
		</div>

	</div>
	<div v-else>

		<h3><i class="fa fa-arrow-up icon-button" v-on:click="upCategory"></i> {{recordName}}s in "{{ selectedCategory.name }}"</h3>

		<widget v-if="showImportRecords && selectedCategory" :title="'Import '+recordName+'s (.csv)'" key="importRecords" header-button="fa-times" v-on:headerButtonClick="showImportRecords = false" class="mt-2">

			<p v-if="selectedCategory">This allows you to upload a list of {{recordName.toLowerCase()}}s into the "{{selectedCategory.name}}" category</p>

			<h4>Fields:</h4>

			<ul>
				<li v-for="label in importColumnLabels">{{label}}</li>
			</ul>

			<p><strong>Example:</strong></p>

			<table class="spreadsheet-table mb-3">
				<tr v-for="(row,index) in importExampleRows">
					<template v-if="index == 0">
						<th></th>
						<th v-for="cell in row">{{cell}}</th>
					</template>
					<template v-else>
						<th>{{index+1}}</th>
						<td v-for="cell in row">{{cell}}</td>
					</template>
				</tr>
			</table>

			<input type="file" class="form-control mb-2" v-on:change="importCSV(recordApiResource,$event)">

		</widget>

		<table-list 
			:fields="listFields"
			:records="mutateRecords(records)"
			:record-name="recordName"
			:records-selectable="true"
			:has-edit="true"
			v-on:edit="editRecord"
			v-on:selectedRecordsChange="setSelecteRecords">

			<p v-if="records.length == 0">Add a new item by clicking the <i class="fa fa-fw fa-ellipsis-v"></i> in the top right.</p>

			<button v-if="selectedRecords.length > 0" class="btn btn-sm btn-light" type="button" v-on:click="sendToCategory">Send to another Category...</button>

		</table-list>

	</div>

	<database-category-edit-modal
		:title="editCategoryModal.title"
		:record="editCategoryModal.record"
		:visible="editCategoryModal.visible"
		:cat-options="categoryOptions"
		:context-category-id="selectedCategory ? selectedCategory.id : 0"
		:api-resource="categoryApiResource"
		v-on:closeModal="editCategoryModal.visible = false"
		v-on:modelChanged="fetchData">
	</database-category-edit-modal>

	<modal-dialog
		:modal-visible="searchModalVisible"
		title="Search Results"
		:submit-visible="false"
		modal-size="modal-lg"
		cancel-button-text="Close"
		v-on:closeModal="searchModalVisible = false">

		<table-list 
			key="searchRecords"
			:fields="listFields"
			:records="mutateRecords(searchedRecords)"
			:record-name="recordName"
			:has-edit="true"
			v-on:edit="editRecordFromSearch">
		</table-list>

	</modal-dialog>

	<modal-dialog
		:modal-visible="deleteConfirmModal.visible"
		:title="deleteConfirmModal.title"
		confirm-button-text="Yes, Delete"
		button-class="btn-outline-danger"
		cancel-button-text="Cancel"
		v-on:confirm="deleteConfirmed"
		v-on:closeModal="deleteConfirmModal.visible = false">

		{{deleteConfirmModal.message}}

	</modal-dialog>

	<modal-dialog
		:modal-visible="sendToCategoryModal.visible"
		title="Move to a different category"
		confirm-button-text="Move"
		cancel-button-text="Cancel"
		:submit-visible="sendToCategoryModal.targetCategory"
		v-on:confirm="confirmSendToCategory"
		v-on:closeModal="sendToCategoryModal.visible = false">

		<p>Select the category to move to</p>

		<tree-category-selector :category-api-resource="categoryApiResource"
			parent-key="category_id"
			v-on:categorySelected="sendToCategoryModal.targetCategory = $event">
		</tree-category-selector>

	</modal-dialog>

	<modal-dialog
		:modal-visible="cantDeleteCategoryMessageVisible"
		title="Delete Category"
		:submit-visible="false"
		cancel-button-text="OK"
		v-on:closeModal="cantDeleteCategoryMessageVisible = false">

		<i class="fa fa-exclamation-triangle"></i>
		Categories can't be deleted until all {{recordName.toLowerCase()}}s are removed from it.

	</modal-dialog>
</div>
</template>

<script type="text/javascript">
import TableList from "@/components/TableList"
import ModalDialog from "@/components/ModalDialog"
import Widget from "@/components/Widget"

import SearchBar from "@/components/SearchBar"
import Field from "@/components/Field"
import Spinner from "@/components/Spinner"

import DatabaseCategoryEditModal from "@/components/super_components/DatabaseCategoryEditModal"
import ContextMenu from "@/layout_fragments/ContextMenu"

import TreeCategorySelector from "@/components/super_components/TreeCategorySelector"

export default {
	components: {
		TableList,
		ModalDialog,
		Widget,
		DatabaseCategoryEditModal,
		Field,
		SearchBar,
		ContextMenu,
		Spinner,
		TreeCategorySelector
	},
	props: [
		"categoryApiResource",
		"recordApiResource",
		"recordName", //string
		"listFields", //TabeList fields array
		"numRecordsField", //string
		"hideRecordImport",//hide the "Import {{Record}}" buttons in the context menu and table?
		"importColumns", //array of column names in the order that they appear on the csv import
		"importColumnLabels", //array of column labels in the order that they appear on the csv import
		"mutateFunction", //mutate function for records
		/**
		* Array to build out example import spreadsheet
		* [
			["A","B"],
			['1/2" EMT',EMT-123]
		* ]
		*/
		"importExampleRows", // array to build out example spreadsheet []
		"searchableFields", //array of column names that search method should look in
		"searchTerms", //if this changes, a search is conducted
		"searchScope",
		"fetchTriggerToggle", //if this changes, fetchData is called
		"recordInclude"//what to include in the record payload, if applicable
	],
	data() {
		return {
			working: true,
			records: [],
			categories: [],
			searchedRecords: [],
			selectedCategory: null,
			selectedRecords: [],
			breadcrumb: [],
			catFields: [
				{label: "Name",key:"name"}
			],
			editCategoryModal: {
				visible: false,
				title: "Edit Category",
				record: {}
			},
			searchModalVisible: false,
			categoryEditPayload: {},
			editCategoryHeading: "Edit Category",
			deleteConfirmModal: {
				visible: false,
				title: "Delete Category",
				message: "Are you sure you want to delete this category",
				deleteFunction: ""
			},
			sendToCategoryModal: {
				visible: false,
				targetCategory: null
			},
			cantDeleteCategoryMessageVisible: false,
			showImportCategories: false,
			showImportRecords: false,
		}
	},
	watch: {
		searchTerms() {
			if (this.searchTerms)
				this.searchRecords(this.searchTerms)
		},
		fetchTriggerToggle() {
			this.fetchData()
		}
	},
	computed: {
		contextMenuItems() {
			let items = []
			if (!this.selectedCategory || !this.categoryCanHaveRecords || this.records.length == 0) {
				items.push({
					text: 'New Category',
					icon: 'fa-plus',
					clickFunction: 'newCategory'
				})

				items.push({
					text: 'Import Categories',
					icon: 'fa-upload',
					clickFunction: 'openImportCategories'
				})
			}

			if (this.selectedCategory) {

				items.push({
					text: 'Edit Category',
					icon: 'fa-pencil-alt',
					clickFunction: 'editCategory'
				})

				let disabled = false
				if (this.selectedChildCategories.length > 0 || this.records.length > 0)
					disabled = true

				items.push({
					text: 'Delete Category',
					icon: 'fa-trash',
					disabled: disabled,
					itemClass: 'text-danger',
					clickFunction: 'confirmDeleteCategory'
				})
			}

			if (items.length > 0) {
				items.push({
					isDivider:true
				})
			}

			if (this.selectedCategory && this.categoryCanHaveRecords) {

				items.push({
					text: "New "+this.recordName,
					icon: "fa-plus",
					clickFunction: "newRecord"
				})

				if (!this.hideRecordImport) {
					items.push({
						text: "Import "+this.recordName+"s",
						icon: 'fa-upload',
						clickFunction: "openImportRecords"
					})
				}
			}

			items.push({
				text: 'Export '+this.recordName+"s",
				icon: 'fa-download',
				clickFunction: 'exportRecords'
			})

			if (this.selectedCategory && this.categoryCanHaveRecords) {
				let disabled = true
				if (this.records.length > 0)
					disabled = false
				
				items.push({
					text: "Delete All "+this.recordName+"s",
					icon: 'fa-trash',
					itemClass: 'text-danger',
					disabled: disabled,
					clickFunction: "confirmDeleteCatRecords"
				})
			}
 
			return items
		},
		categoryCanHaveRecords() {
			if (this.selectedChildCategories.length == 0 || this.records.length > 0)
				return true;
			else
				return false
		},
		categoryOptions() {

			let mutatedCats = this.categories.map(cat => {

				cat.nameWithParent = cat.name
				if (cat.ParentCategory)
					cat.nameWithParent += " (in "+cat.ParentCategory.name+")"

				return cat
			})

			return this.optionify(mutatedCats,"nameWithParent")
		},
		selectedChildCategories() {
			let vm = this

			let selectedCategoryId = 0;

			if (this.selectedCategory) 
				//return top level categories
				selectedCategoryId = this.selectedCategory.id
			else
				selectedCategoryId = 0
			
			return this.categories.filter(cat => {
				if (cat.category_id == selectedCategoryId)
					return true
			})
			
		}
	},
	methods: {
		contextMenuClick(functionName,item) {
			this[functionName]()
		},
		openImportCategories() {
			this.showImportCategories = true
		},
		openImportRecords() {
			this.showImportRecords = true
		},
		mutateRecords(records) {
			let vm = this

			if (this.mutateFunction) 
				return this.mutateFunction(records)
			else {
				return records.map(record => {
					record.parentCategoryName = record[vm.categoryApiResource].name
					record.updatedAt = vm.formatDateTimeToLocal(record.updated_at)

					return record
				})
			}
		},
		findParent(category,categories) {

			let returnCat

			categories.forEach(cat => {
				if (cat.id == category.category_id)
					returnCat = cat
			})

			return returnCat
		},
		//drill down to sub-cateogry
		openCat(cat) {
		
			if (!this.selectedCategory || cat.id != this.selectedCategory.id) {
				this.selectedCategory = cat
				this.breadcrumb.push(cat)

				this.fetchCategories(true)

				this.$emit("categoryChange",this.selectedCategory)

				this.fetchRecords(true)
			}
			
		},
		//jump to a category above
		toCat(cat) {
			this.selectedCategory = cat
			this.$emit("categoryChange",this.selectedCategory)

			//figure out where to splice off the end of the breadcrumb array
			let indexToSplice = this.breadcrumb.map(item => {return item.id}).indexOf(cat.id)+1

			this.breadcrumb.splice(indexToSplice)

			this.fetchCategories(true)

			let vm = this

			return new Promise((resolve,reject) => {
				vm.fetchRecords(true).then(response => {
					resolve(response)
				})
			})
		},
		upCategory() {
			this.selectedCategory = this.breadcrumb[this.breadcrumb.length-2] //second last element will take us up one level
			this.$emit("categoryChange",this.selectedCategory)

			this.fetchCategories(true)

			this.breadcrumb.pop()

			this.fetchRecords(true)
		},
		newRecord() {
			this.$emit("newRecord",this.selectedCategory.id)
		},
		editRecord(record) {
			this.$emit("editRecord",record)
		},
		editRecordFromSearch(record) {
			this.searchModalVisible = false

			let vm = this

			vm.$emit("editRecord",record)

			this.categories.forEach(cat => {
				if (cat.id == record[vm.categoryApiResource].id) 
					vm.toCat(cat)
			})
		},
		setSelecteRecords(records) {
			this.selectedRecords = records
		},
		newCategory() {

			this.editCategoryModal.visible = true

			this.editCategoryModal.title = "Add New Category"

			let category_id = null

			if (this.selectedCategory)
				category_id = this.selectedCategory.id

			this.editCategoryModal.record = {
				category_id: category_id,
				name: ""
			}
		},
		editCategory() {
			this.editCategoryModal.visible = true

			this.editCategoryModal.record = JSON.parse(JSON.stringify(this.selectedCategory))

			this.editCategoryModal.title = "Edit Category"
		},
		saveCategory() {
			let vm = this

			this.saveRecord(this.categoryApiResource,this.categoryEditPayload,response => {
				vm.alertSaved("Category saved!")

				if (vm.selectedCategory === true)
					vm.selectedCategory = false

				vm.fetchRecords(true)
			})
		},
		confirmDeleteCategory() {
			let vm = this

			//check that there are no products in this category
			if (this.records.length == 0) {
				this.deleteConfirmModal.visible = true
				this.deleteConfirmModal.title = "Delete Category"
				this.deleteConfirmModal.message = "Are you sure you want to delete this category?"
				this.deleteConfirmModal.deleteFunction = "deleteCategory"
			}
			else 
				this.cantDeleteCategoryMessageVisible = true
			

		},
		deleteConfirmed() {
			this[this.deleteConfirmModal.deleteFunction]()
		},
		deleteCategory() {
			let vm = this

			this.postData(this.categoryApiResource+"/delete",{id: this.selectedCategory.id}).then(response => {
				vm.alertSuccess("Category Deleted!")

				vm.deleteConfirmModal.visible = false

				vm.categories.splice(
					vm.categories.findIndex(cat => cat && cat.id == vm.selectedCategory.id),1
				)

				vm.upCategory()
			})
		},
		exportRecords() {
			let vm = this

			let catId = 0

			if (this.selectedCategory) 
				catId = this.selectedCategory.id
	
			window.location = window.apiBase+this.recordApiResource+"/get?category_id="+catId+"&include="+JSON.stringify([this.categoryApiResource,'Contact'])+"&format=csv&token="+this.$store.sessionToken
		},
		deleteCatRecords() {
			let vm = this

			let promises = []
			this.records.forEach(mat => {
				promises.push(vm.postData(vm.recordApiResource+"/delete",{id: mat.id}))
			})

			Promise.all(promises).then(responses => {
				vm.alertSuccess("Category "+vm.recordName.toLowerCase()+"s deleted!")

				vm.deleteConfirmModal.visible = false
				vm.fetchRecords(true)
			})
		},
		confirmDeleteCatRecords() {
			this.deleteConfirmModal.visible = true
			this.deleteConfirmModal.title = "Delete "+this.recordName+"s in Category"
			this.deleteConfirmModal.message = "Are you sure you want to delete all the "+this.recordName.toLowerCase()+"s in this category?"
			this.deleteConfirmModal.deleteFunction = "deleteCatRecords"
		},
		sendToCategory() {
			this.sendToCategoryModal.visible = true
		},
		confirmSendToCategory() {
			let vm = this

			let payload = this.selectedRecords.map(mat => {
				return {
					id: mat.id,
					category_id: vm.sendToCategoryModal.targetCategory.id
				}
			})

			let params = {
				records: JSON.stringify(payload)
			}

			this.postData("Material/save-batch",params,true).then(response => {
				if (response.success) {
					vm.alertSaved(response.data.records_saved + " materials moved to " + vm.sendToCategoryModal.targetCategory.name)
					vm.sendToCategoryModal.visible = false
					vm.fetchRecords(true)
					vm.sendToCategoryModal.targetCategory = false
				}
			})
		},
		importCSV(type,evt) {
			let files = evt.target.files; // FileList object
			let f = files[0];

			let vm = this

			let reader = new FileReader();

			let fileValid = true

			let allowedMimes = [
				"text/plain",
				"text/csv",
				"application/vnd.ms-excel"
			]

			//check file extension type
			if (allowedMimes.indexOf(f.type) == -1)
				vm.alertFail("Invalid file format! File must be a CSV")

			else {

				 // Closure to capture the file information.
				reader.onload = (theFile => {
					return e => {
						
						let csvObj = vm.CSVToArray(e.target.result)

						//check if last row is a blank, if so remove it
						if (csvObj[csvObj.length-1].length == 1)
							csvObj.splice(csvObj.length-1,1)

						let recordsPayload, resource, numFields

						if (type == vm.categoryApiResource) {

							resource = vm.categoryApiResource
							numFields = 1

							//check appropriate number of fields per row
							csvObj.forEach(row => {
								if (row.length != numFields)
									fileValid = false
							})

							recordsPayload = csvObj.map(row => {
								let record = {
									name: row[0]
								}

								if (vm.selectedCategory)
									record.category_id = vm.selectedCategory.id

								return record
							})
						}
						else {

							resource = vm.recordApiResource
							numFields = vm.importColumns.length

							//check appropriate number of fields per row
							csvObj.forEach(row => {
								if (row.length != numFields)
									fileValid = false
							})

							recordsPayload = csvObj.map(row => {
								let rowObj = {
									category_id: vm.selectedCategory.id
								}

								vm.importColumns.forEach((field,index) => {
									rowObj[field] = row[index]
								})

								return rowObj
							})
						}

						if (fileValid) {
							vm.spinner(true)

							vm.postData(resource+"/save-batch",{records: JSON.stringify(recordsPayload)}).then(response => {
								vm.alertSaved(response.data.records_saved + " records imported successfully!")

								vm.fetchData()

								vm.spinner(false)
							})
						}
						else 
							vm.alertFail("Invalid CSV format! There must be "+numFields+" fields per row.")
						
					};
				})(f);

				reader.readAsText(f);
			}
		},
		searchRecords(terms) {
			let vm = this

			let filters = []

			if (this.searchScope == "this") {
				this.searchableFields.forEach((field,index) => {

					let andOr = "or"
					if (index == 0)
						andOr = "and"


					filters.push(["category_id",this.selectedCategory.id,andOr])
					filters.push([field,terms,"and","like"])
					
				})
			}
			else {
				this.searchableFields.forEach((field,index) => {

					let andOr = "or"
					if (index == 0)
						andOr = "and"

					filters.push([field,terms,andOr,"like"])
				})
			}

			let include = [this.categoryApiResource]

			if (this.recordInclude)
				include = [...include, ...this.recordInclude]

			let params = {
				include,
				filters
			}

			this.spinner(true)

			vm.getJSON(this.recordApiResource+"/get",params).then(response => {
				vm.searchedRecords = response.data

				vm.searchModalVisible = true

				vm.spinner(false)
			})
		},
		fetchRecords(spinner) {
			let vm = this

			let filters = []

			if (this.selectedCategory) {
				filters = [
					["category_id",this.selectedCategory.id]
				]
			}
			else {
				filters = [
					['category_id',0]
				]
			}

			if (spinner)
				vm.spinner(true)

			let include = [this.categoryApiResource]

			if (this.recordInclude)
				include = [...include, ...this.recordInclude]

			let params = {
				filters,
				include
			}

			return new Promise((resolve,reject) => {
				vm.getJSON(this.recordApiResource+"/get",params).then(response => {

					if (spinner)
						vm.spinner(false)

					vm.records = response.data

					resolve(response)

				})
			})
		},
		fetchCategories(spinner) {
			let vm = this

			if (spinner) {
				vm.spinner(true)
				vm.working = true
			}

			let filters = []
			if (this.selectedCategory) {
				filters = [
					["category_id",this.selectedCategory.id]
				]
			}
			else {
				filters = [
					["category_id", 0]
				]
			}

			let params = {
				include: [{model: vm.categoryApiResource,limit:1}],
				filters
			}

			return new Promise((resolve,reject) => {
				vm.getJSON(vm.categoryApiResource+"/get",params).then(response => {
					if (response.success)
						vm.categories = response.data

					if (spinner) {
						vm.spinner(false)
						vm.working = false
					}

					resolve(response)
				})
			})
		},
		fetchData() {
			let vm = this
			this.working = true

			let promises = [
				this.fetchRecords(false),
				this.fetchCategories(false)
			]

			this.spinner(true)

			Promise.all(promises).then(responses => {
				vm.spinner(false)
				vm.working = false
			})
		}
	},
	created() {
		this.fetchData()
	}
}
</script>

<style type="text/css">
	.categories-list li {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		padding-top: 7px;
		padding-bottom: 7px;
	}

	.categories-list 

	.categories-list a:hover {
		text-decoration: none;
	}

	.categories-list li:hover {
		cursor: pointer;
		background-color: #e0e0e0;
	}

	.count-badge {
		background-color: #2ca2ff;
		border-radius: 50%;
		padding: 5px;
		padding-top: 4px;
		width: 30px;
		height: 30px;
		color: white;
		font-size: 15px;
		font-weight: bold;
		text-align: center;
	}
</style>